export default __webpack_public_path__ + "static/media/geyser-glow.14be807b.png";